<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('root.save_view') }}</h5>
    </template>

    <template #body>
      <form @submit.prevent='saveFilters()'>
        <div class='modal-body'>
          <div class="form-group">
            <label>{{ $t('root.view_name') }}</label>
            <input type="text" v-model='name' class="form-control">
          </div>
        </div>

        <div class='modal-footer'>
          <input type='reset' name='commit' :value="$t('header.cancel')" class='btn btn-neutral' @click.prevent='close'>
          <input type='submit' name='commit' :value="$t('header.save')" class='btn btn-primary' :disabled='!name'>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        name: null
      }
    },
    methods: {
      saveFilters() {
        const fs = Object.assign({}, this.$route.query)

        delete fs['parent_id']
        delete fs['page']
        delete fs['filters[s]']

        const params = {
          item_filter: {
            name: this.name,
            filters: fs,
          }
        }

        this.store.createItemFilter(params).then(() => {
          this.store.getItemFilters()
          this.store.sendMetrics({name: 'create_filter', params: this.$route.params, path: this.$route.fullPath})
          this.close()
        })
      },
      open() {
        this.$refs.modal.open()
      },
      close() {
        this.$refs.modal.close()
      }
    }
  }
</script>
